import React from 'react';
import { diasRestantes, etiquetaDias, fechaCorta } from '../../utils/fechas';
import { ESTILO_SEMAFORO, nivelPorDias } from '../../utils/semaforo';
import type { NivelSemaforo } from '../../types';
export function PuntoSemaforo({
  nivel,
  titulo
}: {
  nivel: NivelSemaforo;
  titulo?: string;
}) {
  return <span className={`inline-block h-2.5 w-2.5 shrink-0 rounded-full ${ESTILO_SEMAFORO[nivel].punto}`} title={titulo ?? ESTILO_SEMAFORO[nivel].etiqueta} aria-hidden="true" data-id="element-922" data-mp="2w03j6rlmgll" />;
}
export function ChipVencimiento({
  fechaLimite,
  mostrarFecha = true
}: {
  fechaLimite?: string;
  mostrarFecha?: boolean;
}) {
  if (!fechaLimite) {
    return <span className="text-2xs uppercase tracking-wide text-gris-400" data-id="element-923" data-mp="3bdwimu15etiz">Sin plazo</span>;
  }
  const dias = diasRestantes(fechaLimite);
  const nivel = nivelPorDias(dias);
  const estilo = ESTILO_SEMAFORO[nivel];
  return <span className="inline-flex items-center gap-2" data-id="element-924" data-mp="vk5nvseqq3kw">
      <PuntoSemaforo nivel={nivel} titulo={estilo.etiqueta} data-id="element-925" data-mp="viuoe4sbvhzl" />
      <span className="tabular text-xs text-gris-700" data-id="element-926" data-mp="17705mdgjztmp">
        {mostrarFecha && <span className="mr-1.5" data-id="element-927" data-mp="13554b8ymhg8x">{fechaCorta(fechaLimite)}</span>}
        <span className={`font-medium ${estilo.texto}`} data-id="element-928" data-mp="135wozoqoltkf">{etiquetaDias(dias)}</span>
      </span>
    </span>;
}
export function ChipDias({
  fechaLimite
}: {
  fechaLimite: string;
}) {
  const dias = diasRestantes(fechaLimite);
  const estilo = ESTILO_SEMAFORO[nivelPorDias(dias)];
  return <span className={`tabular inline-flex items-center rounded px-2 py-0.5 text-2xs font-semibold ${estilo.chip}`} data-id="element-929" data-mp="o9ff71y54mzz">
      {etiquetaDias(dias)}
    </span>;
}